if (document.getElementById("qualifying_question_form")) {
    function showCtaSuccess() {
        document.getElementById("qualifying_question").classList.add("hidden");
        document.getElementById("qualifying_question").hidden = true;
        document.getElementById("cta-success").classList.remove("hidden");
        document.getElementById("cta-success").hidden = false;
    }

    var qualifying_question_form = document.getElementById(
        "qualifying_question_form"
    );

    qualifying_question_form.addEventListener("submit", showCtaSuccess, {
        once: true,
    });
}
